export class XYType {
    constructor(
        public x: number,
        public y: number,
        public r?: number,
        public name?: string,
        public id?: string
    ) {}
}
